import { useQuery } from "react-query";
import { getEmployeeAdOverrideGroup } from "../api";

export default function useGetEmployeeAdOverrideGroup() {
  return useQuery("GetAdOverrideGroup", getEmployeeAdOverrideGroup, {
    refetchOnWindowFocus: false,
  });
}
